export const authRoutePaths = {
  login: '/login',
  auth: '/auth',
  authAttempt: '/auth-attempt',
  logout: '/logout',
} as const;

export const blockedAuthPaths = Object.values(authRoutePaths);
